window.initializeKlaviyoModals = function() {
  const klaviyoPublicKey = "JyHqWZ"; 

  // --- 1. AUTO-CONVERT ALL OOS BUTTONS ---
  const convertButtons = () => {
    const buttonSelectors = '.quick-add__submit[disabled]:not(.klaviyo-bound), .sold-out:not(.klaviyo-bound), .klaviyo-bis-trigger:not(.klaviyo-bound)';
    
    document.querySelectorAll(buttonSelectors).forEach(btn => {
      btn.removeAttribute('disabled');
      btn.classList.add('klaviyo-trigger', 'klaviyo-bound'); 
      
      if (btn.tagName.toLowerCase() === 'button') {
        const primarySpan = btn.querySelector('span:not(.sold-out-message)');
        if (primarySpan) primarySpan.textContent = 'NOTIFY ME';
        else btn.textContent = 'NOTIFY ME';
        
        const hiddenSpan = btn.querySelector('.sold-out-message');
        if (hiddenSpan) hiddenSpan.textContent = 'NOTIFY ME';
      }
    });
  };

  convertButtons();

  // --- 2. GLOBAL EVENT DELEGATION & OBSERVER ---
  if (!window.klaviyoListenersAttached) {
    window.klaviyoListenersAttached = true;

    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('.klaviyo-trigger, .klaviyo-bis-trigger');
      if (!trigger) return;

      e.preventDefault(); 
      
      const form = trigger.closest('form');
      const card = trigger.closest('.card-wrapper, .product-form, .grid__item');

      // --- NEW: PARSE PRODUCT JSON (For Product Pages) ---
      let jsonProduct = null;
      const jsonScript = document.querySelector('script[type="application/json"][id^="ProductJson-"]');
      if (jsonScript) {
        try {
          jsonProduct = JSON.parse(jsonScript.textContent);
        } catch (err) {
          console.warn("[Klaviyo] Could not parse Product JSON", err);
        }
      }

      // --- EXTRACT PRODUCT ID ---
      const productInput = form ? form.querySelector('[name="product-id"]') : document.querySelector('[name="product-id"]');
      let productId = trigger.dataset.productId || (productInput ? productInput.value : '');
      if (!productId && jsonProduct) productId = jsonProduct.id;

      // --- EXTRACT VARIANT ID ---
      let variantId = trigger.dataset.variantId;
      if (!variantId) {
        let vInput = form ? form.querySelector('[name="id"]') : null;
        if (!vInput) vInput = document.querySelector('[name="id"]');
        
        if (vInput && vInput.value) {
          variantId = vInput.value;
        } else {
          const urlParams = new URLSearchParams(window.location.search);
          variantId = urlParams.get('variant');
        }
      }
      // JSON Fallback for Variant ID
      if (!variantId && jsonProduct && jsonProduct.variants && jsonProduct.variants.length > 0) {
        variantId = jsonProduct.variants[0].id;
      }
      // Global Meta Fallback for Variant ID
      if (!variantId && window.meta && window.meta.product && window.meta.product.variants && window.meta.product.variants.length > 0) {
        variantId = window.meta.product.variants[0].id;
      }

      // --- EXTRACT TITLE (Fixed to prevent grabbing Collection H1) ---
      let productTitle = trigger.dataset.productTitle;
      
      if (!productTitle) {
        // 1. Check inside the specific product card first (Collection Page)
        const cardTitleEl = card ? card.querySelector('.card__heading, h3') : null;
        if (cardTitleEl) {
          productTitle = cardTitleEl.textContent.trim();
        } 
        // 2. Fallback to the JSON script (Product Page)
        else if (jsonProduct && jsonProduct.title) {
          productTitle = jsonProduct.title;
        } 
        // 3. Strict fallback to Product Page H1 only (ignores Collection H1)
        else {
          const pageH1 = document.querySelector('.product__title h1, h1.product-single__title');
          productTitle = pageH1 ? pageH1.textContent.trim() : 'this item';
        }
      }
      
      if (!productId || !variantId) {
        console.error('[Klaviyo Debug] Missing Variant ID.', { productId, variantId });
        alert("We're having trouble locating the specific variant for this product. Please refresh the page and try again.");
        return; 
      }

      // --- RENDER MODAL ---
      const modalId = `klaviyo-modal-${productId}`;
      let klaviyoModal = document.getElementById(modalId);

      if (!klaviyoModal) { 
        klaviyoModal = document.createElement('div');
        klaviyoModal.id = modalId;
        klaviyoModal.style.cssText = `display: none; position: fixed; z-index: 10000; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.65);`;
        klaviyoModal.innerHTML = `
          <div style="background-color: white; margin: 15% auto; padding: 20px; border: 1px solid #888; width: 80%; max-width: 600px; position: relative; border-radius: 3px; padding: 30px 40px;">
            <button style="position: absolute; top: 7px; right: 15px; font-size: 30px; font-weight: 700; line-height:1; cursor: pointer; color: #ccc; -webkit-appearance: none; background: none; border: none;" onclick="closeKlaviyoModal('${modalId}')">&times;</button>
            <h3>${productTitle}</h3> <p style="margin-bottom: 1rem;">Receive a notification when this product is available.</p>
            <form id="klaviyo-subscribe-form-${productId}" style="display: flex; flex-direction: column; gap: 30px;">
              <input type="email" id="klaviyo-email-${productId}" placeholder="Email" required aria-label="Email" style="font-size: 14px; height: 46px; padding: 10px 16px; line-height: 1.3333333; background-color: #fff; background-image: none; border: 1px solid #ccc; border-radius: 2px; box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075); transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;">
              <button type="submit" class="button" style="width: 100%;">Notify Me</button>
              <div id="error_message-${productId}" class="error_message alert alert-danger" style="display: none;"></div>
              <div id="completed_message-${productId}" class="klaviyo-success completed_message alert alert-success" style="display: none;">You will be notified when this item is back in stock. <a href="#" onclick="closeKlaviyoModal('${modalId}')" style="color: #2C1203;">Close</a></div>
            </form>
          </div>
        `;
        document.body.appendChild(klaviyoModal);

        klaviyoModal.addEventListener('click', function(event) {
          if (event.target === klaviyoModal) {
            closeKlaviyoModal(modalId);
          }
        });

        const klaviyoForm = document.getElementById(`klaviyo-subscribe-form-${productId}`);
        const klaviyoEmail = document.getElementById(`klaviyo-email-${productId}`);
        const errorMessage = document.getElementById(`error_message-${productId}`);
        const completedMessage = document.getElementById(`completed_message-${productId}`);

        klaviyoForm.addEventListener('submit', (event) => {
          event.preventDefault();
          const email = klaviyoEmail.value;

          const payload = {
            "data": {
              "type": "back-in-stock-subscription",
              "attributes": {
                "profile": { "data": { "type": "profile", "attributes": { "email": email } } },
                "channels": ["EMAIL"]
              },
              "relationships": {
                "variant": { "data": { "type": "catalog-variant", "id": `$shopify:::$default:::${variantId}` } }
              }
            }
          };

          const requestOptions = {
            method: 'POST',
            headers: { "Content-Type": "application/json", "revision": "2024-06-15" },
            body: JSON.stringify(payload),
          };

          errorMessage.style.display = 'none'; 
          completedMessage.style.display = 'none'; 

          fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoPublicKey}`, requestOptions)
            .then(response => {
              if (response.status === 202) {
                completedMessage.style.display = 'block';
                klaviyoForm.reset();
              } else {
                errorMessage.textContent = "There was an error subscribing. Please try again."; 
                errorMessage.style.display = 'block';
              }
            })
            .catch(error => {
              errorMessage.textContent = "There was a network error. Please try again."; 
              errorMessage.style.display = 'block';
            });
        });
      }

      klaviyoModal.style.display = 'block';
      setTimeout(() => {
        const klaviyoEmail = document.getElementById(`klaviyo-email-${productId}`);
        if (klaviyoEmail) klaviyoEmail.focus();
      }, 200);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        const visibleModals = document.querySelectorAll('[id^="klaviyo-modal-"]');
        visibleModals.forEach(modal => {
          if (modal.style.display === 'block') closeKlaviyoModal(modal.id);
        });
      }
    });

    // Bulletproof Observer 
    let debounceTimer;
    const bodyObserver = new MutationObserver((mutations) => {
      const hasNewNodes = mutations.some(mutation => mutation.addedNodes.length > 0);
      if (hasNewNodes) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          convertButtons();
        }, 250); 
      }
    });
    
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
};

window.closeKlaviyoModal = function(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.style.display = 'none';
    const errorMessage = modal.querySelector('.error_message');
    const completedMessage = modal.querySelector('.completed_message');
    if (errorMessage) errorMessage.style.display = 'none'; 
    if (completedMessage) completedMessage.style.display = 'none'; 
  }
};

document.addEventListener('DOMContentLoaded', function() { 
  window.initializeKlaviyoModals(); 
});